import React from "react";
import { IconButton, styled } from "@mui/material";

const BladeIconButton = styled(IconButton)(({ theme }) => ({
    "&:hover": { backgroundColor: "initial", color: theme.palette.primary.light },
    "&:active": {
      backgroundColor: "initial",
      color: theme.palette.primary.light,
    },
    "&:active:hover": {
      backgroundColor: "initial",
      color: "theme.palette.primary.light",
    },
  }));

  export default BladeIconButton;
